<!-- 


<div class="login-wrapper">
  <div class="login-left">
    <div class="illustration">
      <img src="assets/ai-support-illustration.svg" alt="AI Support" />
      <h2>CustomerCare AI</h2>
      <p>
        Empowering businesses with AI-powered customer engagement.
        <br />Smart, fast, and personalized assistance.
      </p>
    </div>
  </div>

  <div class="login-right">
    <div class="login-box">
      <div class="logo-container">
        <img src="assets/icons/fav_1.png" alt="CustomerCare AI Logo" class="logo" />
        <h1 class="brand">CustomerCare <span>AI ChatBot</span></h1>
      </div>

      <form (submit)="onLogin()" class="login-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            [(ngModel)]="email"
            type="email"
            required
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input
            matInput
            [(ngModel)]="password"
            [type]="passwordType"
            required
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-icon matSuffix (click)="togglePassword()">lock</mat-icon>
        </mat-form-field>

        <button mat-raised-button  type="submit" class="login-btn">
          Sign In
        </button>

        <p *ngIf="error" class="error">{{ error }}</p>

        <button mat-button class="forgot-password" (click)="toggleReset()">
          Forgot Password?
        </button>

        <div class="reset-section" *ngIf="showReset">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Reset Email</mat-label>
            <input
              matInput
              [(ngModel)]="resetEmail"
              placeholder="Enter email for reset"
              [ngModelOptions]="{ standalone: true }"
            />
            <mat-icon matSuffix>email</mat-icon>
          </mat-form-field>

          <button
            mat-raised-button
            color="accent"
            class="reset-button"
            (click)="onResetPassword($event)"
          >
            Send Reset Link
          </button>
          <p *ngIf="resetSuccess" class="success">{{ resetSuccess }}</p>
          <p *ngIf="resetError" class="error">{{ resetError }}</p>

          <button mat-button class="cancel-button" (click)="toggleReset()">Cancel</button>
        </div>
      </form>

      <footer class="footer">
        © 2025 ruecart.com. All rights reserved.
      </footer>
    </div>
  </div>
</div> -->

<div class="login-wrapper">
  <div class="login-left">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>

    <div class="illustration">
      <img src="assets/ai-support-illustration.svg" alt="AI Support" />
      <h2>CustomerCare AI</h2>
      <p>
        Empowering businesses with AI-powered customer engagement.
        <br />Smart, fast, and personalized assistance.
      </p>
    </div>
  </div>

  <div class="login-right">
    <div class="login-box">
      <div class="logo-container">
        <!-- <img src="assets/icons/fav_1.png" alt="CustomerCare AI Logo" class="logo" /> -->
         <img src="assets/images/logo.jpeg" alt="CustomerCare AI Logo" class="logo" />
        <h1 class="brand">CustomerCare <span>AI ChatBot</span></h1>
      </div>

      <form (submit)="onLogin()" class="login-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            [(ngModel)]="email"
            type="email"
            required
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input
            matInput
            [(ngModel)]="password"
            [type]="passwordType"
            required
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-icon matSuffix (click)="togglePassword()">lock</mat-icon>
        </mat-form-field>

        <button mat-raised-button type="submit" class="login-btn">
          Sign In
        </button>

        <p *ngIf="error" class="error">{{ error }}</p>

        <button mat-button class="forgot-password" (click)="toggleReset()">
          Forgot Password?
        </button>

        <div class="reset-section" *ngIf="showReset">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Reset Email</mat-label>
            <input
              matInput
              [(ngModel)]="resetEmail"
              placeholder="Enter email for reset"
              [ngModelOptions]="{ standalone: true }"
            />
            <mat-icon matSuffix>email</mat-icon>
          </mat-form-field>

          <button
            mat-raised-button
            color="accent"
            class="reset-button"
            (click)="onResetPassword($event)"
          >
            Send Reset Link
          </button>
          <p *ngIf="resetSuccess" class="success">{{ resetSuccess }}</p>
          <p *ngIf="resetError" class="error">{{ resetError }}</p>

          <button mat-button class="cancel-button" (click)="toggleReset()">Cancel</button>
        </div>
      </form>

      <footer class="footer">
        © 2025 ruecart.com. All rights reserved.
      </footer>
    </div>
  </div>
</div>
